import { createTheme, alpha } from "@mui/material";

export const DRAWER_WIDTH = 280;
export const DRAWER_WIDTH_COLLAPSED = 72;

export const buildHomeV2Theme = (mode) =>
  createTheme({
    typography: {
      fontFamily: '"Segoe UI", Roboto, Helvetica, Arial, sans-serif',
      button: { textTransform: "none", fontWeight: 600 },
    },
    shape: { borderRadius: 10 },
    components: {
      MuiDrawer: {
        styleOverrides: {
          paper: {
            borderRight: "none",
            backgroundImage: "none",
            backgroundColor: mode === "dark" ? "#0E1620" : "#FFFFFF",
          },
        },
      },
      MuiListItemButton: {
        styleOverrides: {
          root: {
            borderRadius: 10,
            marginBottom: 2,
          },
        },
      },
    },
    palette: {
      mode,
      ...(mode === "light"
        ? {
            primary: { main: "#1B3A4B", light: "#2E5A70", dark: "#122830" },
            secondary: { main: "#E8A317", light: "#F0BC4A", dark: "#C4890F" },
            background: { default: "#F3F6F8", paper: "#FFFFFF" },
            divider: alpha("#1B3A4B", 0.12),
            text: {
              primary: "#152A36",
              secondary: alpha("#152A36", 0.72),
            },
          }
        : {
            primary: { main: "#5BA3BC", light: "#7FB8CC", dark: "#3D7F96" },
            secondary: { main: "#E8A317", light: "#F0BC4A", dark: "#C4890F" },
            background: { default: "#0B1520", paper: "#122230" },
            divider: alpha("#FFFFFF", 0.1),
            text: {
              primary: "#E8F0F4",
              secondary: alpha("#E8F0F4", 0.7),
            },
          }),
    },
  });
